import axios from '@/libs/api.request'

export const companyList = data => {
  return axios.request({
    url: '/print/company/list',
    params: data,
    method: 'get'
  })
}
export const companyUpdate = data => {
  return axios.request({
    url: '/print/company/update',
    data,
    method: 'put'
  })
}
export const companyInsert = data => {
  return axios.request({
    url: '/print/company/insert',
    data,
    method: 'put'
  })
}
export const companyInfo = data => {
  return axios.request({
    url: '/print/company/info',
    params: data,
    method: 'get'
  })
}
export const SearchCompany = data => {
  return axios.request({
    url: '/print/company/search',
    params: data,
    method: 'get'
  })
}
export const CompanyRecharge = data => {
  return axios.request({
    url: '/print/company/recharge',
    data,
    method: 'put'
  })
}
export const CompanyRechargeLog = data => {
  return axios.request({
    url: '/print/company/recharge/log',
    params: data,
    method: 'get'
  })
}
export const CompanyRechargeConfirm = data => {
  return axios.request({
    url: '/print/company/recharge/confirm',
    data,
    method: 'put'
  })
}
export const CompanyUserName = params => {
  return axios.request({
    url: '/print/company/username',
    params,
    method: 'get'
  })
}
